module.exports = __webpack_public_path__ + "img/flora_firstserum.0a973f62.jpg";